import React from 'react';
import { Text } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import P from '@leverege/promise';
import { Blocker } from '@leverege/molten/views';
import { jsx as _jsx } from "react/jsx-runtime";
class SaleVoidedBy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null
    };
    this.initialLoad = P.deferred();
  }
  componentDidMount() {
    this._isMounted = true;
    const {
      original,
      context
    } = this.props;
    const voidedBy = original?.data?.data?.voidedBy || context?.data?.data?.voidedBy;
    // Handle PEN and empty voidedBy up front — no API call
    if (!voidedBy) {
      this.setState({
        data: '-'
      });
      this.initialLoad.resolve();
      return;
    }
    if (voidedBy === 'PEN') {
      this.setState({
        data: 'PEN'
      });
      this.initialLoad.resolve();
      return;
    }

    // For other cases, fetch user name
    GlobalState.dispatch((dispatch, getState, {
      api
    }) => {
      return api.system(process.env.SYSTEM_ID).srv('recovr').get(`searchUsers/getUserName?userId=${voidedBy}`);
    }).then(item => {
      const value = typeof item === 'string' ? item : item?.email || '-';
      if (this._isMounted) {
        this.setState({
          data: value
        });
      }
      this.initialLoad.resolve();
    }).catch(err => {
      console.error({
        err
      }, 'Could not get user name');
      this.setState({
        data: '-'
      });
      this.initialLoad.resolve();
    });
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  renderChildren = () => {
    const {
      data
    } = this.state;
    return /*#__PURE__*/_jsx(Text, {
      variant: "columnValue",
      children: data || '-'
    });
  };
  render() {
    const matchContext = {
      client: 'SaleVoidedBy'
    };
    return /*#__PURE__*/_jsx(Blocker, {
      matchContext: matchContext,
      context: this.props,
      hooks: [{
        execute: () => this.initialLoad
      }],
      render: this.renderChildren,
      small: true,
      loadingProps: {
        inline: true
      }
    });
  }
}
export default SaleVoidedBy;